/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Web_EyebrowInputs */

const tr_landing_web_eyebrow = /** @type {(inputs: Landing_Web_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emonse Web · kendi mağazanız`)
};

const en_landing_web_eyebrow = /** @type {(inputs: Landing_Web_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emonse Web · your own store`)
};

const de_landing_web_eyebrow = /** @type {(inputs: Landing_Web_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emonse Web · Ihr eigener Shop`)
};

const ru_landing_web_eyebrow = /** @type {(inputs: Landing_Web_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emonse Web · ваш собственный магазин`)
};

/**
* | output |
* | --- |
* | "Emonse Web · your own store" |
*
* @param {Landing_Web_EyebrowInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_web_eyebrow = /** @type {((inputs?: Landing_Web_EyebrowInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Web_EyebrowInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_web_eyebrow(inputs)
	if (locale === "de") return de_landing_web_eyebrow(inputs)
	if (locale === "ru") return ru_landing_web_eyebrow(inputs)
	return tr_landing_web_eyebrow(inputs)
});